export const pageTitle = title => {
  return (document.title = title + ' - We Make Your Ideas Go Live!');
};
